import { SingletonManager } from "../../helpers/singletonInitializer.ts";
import * as THREE from "three";
import { changeCameraLayers as changeCameraLayersSplit } from "./Split.jsx";
import { globalData } from "../../helpers/globData.ts";
import { changeCameraLayers, measurementTool } from "./Mesh.jsx";
import { rootsValues } from "../../utils/enums.js";

export const RB = {
  skull: undefined,
  mandible: undefined,
  teeth: new Array(32),
}; // Roots and Bones
let rootMaterial =
  SingletonManager.materialManager.getMaterial("teethMaterial");
const boneMaterial =
  SingletonManager.materialManager.getMaterial("boneMaterial");
export function createRoot(geometry, name) {
  geometry.computeVertexNormals();
  const root = new THREE.Mesh(geometry, rootMaterial);
  root.name = `t${name}`; // Assign name for identification

  root.layers.set(2);

  RB.teeth[name] = root;
}

export function createBone(geometry, name) {
  const bone = new THREE.Mesh(geometry, boneMaterial);
  geometry.computeVertexNormals();

  bone.name = name;
  bone.layers.set(3);
  RB[name] = bone;
}

export function enableLayersOf(rootsState) {
  switch (rootsState) {
    case rootsValues.GUM:
      globalData.cameraLayer = [0, 1];
      globalData.lightLayer = [0, 1];

      measurementTool.setRayCastLayers([0, 1]);
      changeCameraLayers([0, 1]);
      changeCameraLayersSplit([0, 1]);
      break;
    case rootsValues.ROOTS:
      globalData.cameraLayer = [0, 2];
      globalData.lightLayer = [0, 2];

      measurementTool.setRayCastLayers([0, 2]);
      changeCameraLayers([0, 2]);
      changeCameraLayersSplit([0, 2]);
      break;
    case rootsValues.ROOTS_BONES:
      globalData.cameraLayer = [0, 2, 3];
      globalData.lightLayer = [0, 2, 3];

      measurementTool.setRayCastLayers([0, 2]);
      changeCameraLayers([0, 2, 3]);
      changeCameraLayersSplit([0, 2, 3]);
      break;
  }
}
